"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sparql = sparql;
const fetchHelp_1 = require("./fetchHelp");
function sparql(query, sparqlEndpoint, acceptCachedResults) {
    const cacheHeader = acceptCachedResults
        ? {} //server decides how old the cache can get
        : { 'Cache-Control': 'no-cache' };
    return fetch(sparqlEndpoint, {
        method: 'post',
        headers: new Headers({
            ...cacheHeader,
            'Accept': 'application/json',
            'Content-Type': 'text/plain'
        }),
        body: query.text
    })
        .then(fetchHelp_1.checkStatus)
        .then(response => response.json());
}
